import React from "react";
import './FundsSecurity.css';
import LayoutMain from "../../../Elements/LayoutMain/LayoutMain";
import IfYouHaveQuestions from "../../../Elements/LayoutMain/IfYouHaveQuestions/IfYouHaveQuestions";


function FundsSecuritySource (props) {
    function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
    } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}


        return (
            <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['ElementMenuActive','','','','','']} Active={0}>
                <main className="FundsSecurityPage StandartPage">
                    <div className="StandartIn">
                        <div className="ProfiforexStandartText">
                            We do more than others to make forex more simple and understandable.
                            <br/>
                            We believe that relationships with your broker should be reliable and predictable, that's why we devote a lot of attention to transparency of our conditions and take every effort to get all the conditions clearly stated on our website.
                            <p/>
                            Our main principle is honesty. We try to be simple and transparent. We want to make sure that you feel safe and comfortable with us.
                        </div>
                        <div className="StandartTitleOut StandartTitleTop">
                            <div className="StandartTitle">How do we guarantee safety of your funds:</div>
                            {props.Adminka ? <div/> : <IfYouHaveQuestions lang={props.lang}/>}
                        </div>
                        <div className="FundsSecurityPageElement">
                            <div className="StandartH2">Segregated Clients</div>
                            <div className="ProfiforexStandartText">Profiforex keeps clients' funds segregated from our company funds
                                <br/>We work only with AA+ rated banks (AA+ rating means the very strong capacity to meet financial commitments)
                            </div>
                        </div>
                        <div className="FundsSecurityPageElement">
                            <div className="StandartH2">STP Technology</div>
                            <div className="ProfiforexStandartText">We use STP technology for executing your orders
                                <br/>It means that we provide access to the interbank market without passing orders through dealing desk.
                            </div>
                        </div>
                        <div className="FundsSecurityPageElement">
                            <div className="StandartH2">Regulated Liquidity Providers</div>
                            <div className="ProfiforexStandartText">We use only regulated liquidity providers.
                                <br/>It guarantees that your orders will be filled following the strict industry standards.
                            </div>
                        </div>
                        <div className="FundsSecurityPageElement">
                            <div className="StandartH2">Deposit and Withdrawal Policy</div>
                            <div className="ProfiforexStandartText">Our deposit and withdrawal policy guarantees the highest level of security.
                                <br/>Money from your trading account can be withdrawn only to the same account from which the deposit was made. It means that nobody else except you can use your money in any way.
                            </div>
                        </div>
                    </div>
                </main>
            </LayoutMain>

        )}

export default FundsSecuritySource